// extracted by mini-css-extract-plugin
module.exports = {"friends":"Friends_friends__2AlGp","hp-bar-wrapper":"Friends_hp-bar-wrapper__1dHgs"};